import Vue from 'vue'
import Router from 'vue-router'
import _import from './_import'
import BeforeGuard from './BeforeGuard'
import AuthModule from './modules/auth'
import ProjectModule from './modules/project'
import AdminModule from './modules/admin'
import StaffModule from './modules/staff'
import DepartmentModule from './modules/department'
import RoleModule from './modules/role'
import ExternalModule from './modules/external'

Vue.use(Router)

const routes = [{
  path: '/',
  name: 'index',
  redirect: '/auth',
}, {
  path: '/auth',
  name: 'auth',
  component: _import('layout/Layout'),
  redirect: '/auth/staffs',
  children: []
    .concat(AdminModule)
    .concat(StaffModule)
    .concat(DepartmentModule)
    .concat(RoleModule),
}, {
  path: '/permission-denied',
  name: 'permission-denied',
  component: _import('PermissionDenied'),
}, { // 一个古老的页面，一些旧模块用到了，先搬移过来
  path: '/wx/choice-project',
  name: 'choice-project',
  component: _import('wx/ChoiceProject.vue'),
  meta: {
    title: '选择项目',
  },
}]
  .concat(AuthModule)
  .concat(ProjectModule)
  .concat(ExternalModule)

const router = new Router({
  routes,
})

router.beforeEach(BeforeGuard)

export default router
